import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Input, message, Checkbox } from 'antd';
import { graphql, compose } from 'react-apollo';
import validationRegex from '@eumentis-cloud/js-validation-regex';

import CreateRetainerClientContactMutation from '../graphql/mutations/createRetainerClientContactMutation.graphql';

const FormItem = Form.Item;

class RetainerClientCreateContactForm extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      submittingForm: true,
    });

    const { form, mutate, retainerClientId } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        mutate({ variables: { retainerClientId, ...values } })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            form.resetFields();
            message.success('Contact created!');
          })
          .catch((err1) => {
            this.setState({
              submittingForm: false,
            });
            console.log(err1);
            message.error(err1.message);
          });
      } else {
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { submittingForm } = this.state;
    const { form } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Form onSubmit={this.handleSubmit}>
        <FormItem label="Full Name" hasFeedback>
          {getFieldDecorator('name', {
            rules: [{ required: true, message: 'Field is required!' }],
          })(<Input required disabled={submittingForm} />)}
        </FormItem>
        <FormItem label="Mobile" hasFeedback>
          {getFieldDecorator('mobile', {
            rules: [
              { required: true, message: 'Field is required!' },
              { pattern: validationRegex.mobile, message: 'Incorrect value' },
            ],
          })(<Input required addonBefore="+91" disabled={submittingForm} />)}
        </FormItem>
        <FormItem label="Email" hasFeedback>
          {getFieldDecorator('email', {
            rules: [{ required: true, message: 'Field is required!' }, { type: 'email', message: 'Incorrect value' }],
          })(<Input required disabled={submittingForm} />)}
        </FormItem>
        <FormItem label="Designation" hasFeedback>
          {getFieldDecorator('designation', {
            rules: [{ required: true, message: 'Field is required!' }],
          })(<Input required disabled={submittingForm} />)}
        </FormItem>
        <FormItem label="Send SMS Updates?">
          {getFieldDecorator('smsUpdates', {
            initialValue: false,
          })(
            <Checkbox disabled={submittingForm}>
              Select if SMS for OTP & updates should be sent to this contact.
            </Checkbox>,
          )}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit" loading={submittingForm}>
            Submit
          </Button>
        </FormItem>
      </Form>
    );
  }
}

RetainerClientCreateContactForm.propTypes = {
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  mutate: PropTypes.func.isRequired,
  retainerClientId: PropTypes.number.isRequired,
};

export default compose(
  graphql(CreateRetainerClientContactMutation),
  Form.create(),
)(RetainerClientCreateContactForm);



// WEBPACK FOOTER //
// ./src/forms/RetainerClientCreateContactForm.jsx